exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-6473262c]{font-size:12px;color:#333}.title-tips span[data-v-6473262c]{color:#999}.iconfont-diy[data-v-6473262c],.iconfont[data-v-6473262c]{font-size:20px;line-height:18px}", ""]);

// exports
